import { useList } from 'react-use'
import { useCallback, useEffect, useState } from 'react'
import { ReferralLink } from '../../../types/referral-links.types'
import { useFetchReferralLinks } from '../use-fetch-referral-links'

interface UseReferralLinks {
  loading: boolean
  error: boolean
  success: boolean
  referralLinks: ReferralLink[]
}

export const useReferralLinks = (): UseReferralLinks => {
  const [success, setSuccess] = useState(false)
  const { fetchReferralLinks, loading, error } = useFetchReferralLinks()

  const [
    referralLinks,
    { set: setListReferralLinks, clear: clearReferralLinks }
  ] = useList<ReferralLink>([])

  const fetchData = useCallback(async () => {
    const list: ReferralLink[] = await fetchReferralLinks()

    return list
  }, [fetchReferralLinks])

  useEffect(() => {
    const start = async (): Promise<void> => {
      const list: ReferralLink[] = await fetchData()

      if (list?.length) {
        setListReferralLinks(list)
      }

      setSuccess(true)
    }

    start()

    return (): void => {
      clearReferralLinks()
    }
  }, [fetchData, setListReferralLinks, clearReferralLinks])

  return {
    loading,
    error,
    success,
    referralLinks
  }
}
